import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from '@yourcause/common/logging';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

   constructor (
    private logger: LogService
  ) {
    super();
  }

  handleError (error: any) {
    if (!!error) {
      if (error?.message?.startsWith('ExpressionChangedAfterItHasBeenCheckedError')) {
        return;
      }
      if (error?.message?.includes('Resize Observer loop completed with undelivered notifications')) {
        // We do not use "ResizeObserver" in our app at all
        // But this error is being thrown likely by users who have an unknown extension that is causing this
        // It doesn't actually break the page, it just throws continual errors in the console
        // Since we don't have any control over this, do not log it since there's nothing we can do and it clogs the logs
        return;
      }
      this.logger.error(error);

    }
    super.handleError(error);
  }
}
